<!-- subscription-plan.component.html - FIXED VERSION -->
<div class="sp-main-container">
  <div class="sp-container">
    <div class="sp-header-details-container">
      <span class="sp-plans-header">Subscription Plans</span>
      <div class="sp-header-details">
        <span *ngIf="!activePlan || activePlan.is_active === false">
          Please choose a plan to continue.
        </span>
        <span *ngIf="activePlan?.is_active === true">
          Choose your plan - Current: <strong>{{ activePlan?.name }}</strong>
        </span>
      </div>
    </div>


    <div class="billing-toggle-container">
      <div class="billing-toggle">
        <button class="toggle-option" [class.active]="selectedBillingPeriod === 'monthly'"
          (click)="setBillingPeriod('monthly')">
          Monthly
        </button>
        <button class="toggle-option" [class.active]="selectedBillingPeriod === 'yearly'"
          (click)="setBillingPeriod('yearly')">
          Yearly
        </button>
      </div>
    </div>
    <!-- <h1
      class="text-3xl mt-2 font-bold text-center leading-tight text-gray-900 dark:text-white max-md:text-2xl max-md:leading-snug max-md:text-center"
      style="opacity: 1; transform: none;">This offer will be expired after : <span
        class="bg-gradient-to-r from-blue-600 via-blue-500 to-blue-700 dark:from-blue-400 dark:via-blue-300 dark:to-blue-500 bg-clip-text text-transparent">{{offerDate}}</span>
    </h1> -->




    <div class="sp-plans-container">
      <div *ngFor="let plan of filteredPlans" class="sp-plans-and-purchase-button"
        [ngClass]="{'current-plan-container': isCurrentPlan(plan)}">
        <div class="sp-plan-card" [ngClass]="{'current-plan-card': isCurrentPlan(plan)}">
          <div class="sp-plan-badge"
            *ngIf="!isCurrentPlan(plan) && activePlan && !activePlan.isFreeTrial && getButtonText(plan)==='Upgrade'">
            <span class="upgrade-badge">Upgrade</span>
          </div>
          <div class="sp-plan-badge"
            *ngIf="!isCurrentPlan(plan) && activePlan && !activePlan.isFreeTrial  && getButtonText(plan)==='Downgrade'">
            <span class="downgrade-badge">Downgrade</span>
          </div>

          <div class="sp-plan-name">{{ plan.name }}</div>

          <div class="sp-plan-details">
            <div *ngFor="let feature of plan.displayFeatures" class="sp-offering-container">
              <div class="sp-feature-container">
                <i [ngClass]="feature.is_present ? 'fa-regular fa-circle-check': 'fa-regular fa-circle-xmark text-red-500'"
                  style="font-size: 24px;" [style]="!feature?.is_present ? 'color:red': ''"></i>
                <p class="sp-feature-description text-sm">{{ feature?.description }}</p>
              </div>
            </div>
          </div>
          <div class="sp-price-container">
            <p class="sp-price">
              <span class="line-through text-gray-400 text-sm mr-2"
                *ngIf="selectedBillingPeriod === 'yearly' && plan.pricing?.yearly?.original">
                ${{ plan.pricing?.yearly?.original }}
              </span>
              <span class="line-through text-gray-400 text-sm mr-2"
                *ngIf="selectedBillingPeriod === 'monthly' && plan.pricing?.monthly?.original">
                ${{ plan.pricing?.monthly?.original }}
              </span>
              ${{ selectedBillingPeriod === 'yearly'
              ? plan.pricing?.yearly?.discounted
              : plan.pricing?.monthly?.discounted }}
            </p>
            <p class="sp-extra">
              {{ selectedBillingPeriod === 'monthly' ? 'Per Month' : 'Per Year' }}
            </p>
            
            <p class="text-xl">
              {{getDiscountedPercentage(plan) ? '(' + getDiscountedPercentage(plan) + '% off)' : ''}}
            </p>
          </div>
        </div>

        <button [ngClass]="getButtonClass(plan)" [disabled]="isCurrentPlan(plan)" (click)="selectPlan(plan)">
          {{ getButtonText(plan) }}
        </button>
      </div>
    </div>

    <span *ngIf="!activePlan && isEligibleForFreeTrial" (click)="startFreeTrial()"
      class="text-white text-center text-lg self-center mt-12 cursor-pointer hover:font-bold">
      Start 14-day Free Trial.
      <br />
      <span class="text-sm opacity-[0.5]">Get 2 SSL Certificates & 1 Pen Testing for Free!</span>
    </span>

    <span *ngIf="canCancelSubscription()" (click)="showCancelConfirmation()"
      class="text-white text-center text-lg self-center mt-12 cursor-pointer hover:font-bold">
      Cancel Subscription
      <br />
      <span class="text-sm opacity-[0.5]" *ngIf="isFreeTrial()">
        Your free trial will be cancelled immediately
      </span>
      <span class="text-sm opacity-[0.5]" *ngIf="!isFreeTrial()">
        Your subscription will remain active until the end of the billing period
      </span>
    </span>

    <span *ngIf="showCancelledTrialBanner" class="text-yellow-400 text-center text-lg self-center mt-12">
      <i class="fa-solid fa-info-circle mr-2"></i>
      Your free trial has been cancelled.
    </span>

    <!-- Show scheduled cancellation for paid plan -->
    <span *ngIf="isCancelledButActive() && !isFreeTrial()"
      class="text-yellow-400 text-center text-lg self-center mt-12">
      <i class="fa-solid fa-info-circle mr-2"></i>
      Your subscription is scheduled to cancel on {{ formatDate(activePlan?.scheduled_cancel_date) }}.
      <br />
      <span class="text-sm opacity-[0.5]">You can resubscribe before this date.</span>
    </span>
    <div>

    </div>
  </div>
</div>

<!-- Plan Change Confirmation Dialog - FIXED VERSION -->
<div *ngIf="showConfirmationDialog" class="confirmation-overlay">
  <div class="confirmation-dialog">
    <div class="confirmation-header">
      <h3>Confirm Plan Change</h3>
    </div>

    <div class="confirmation-content">
      <div class="plan-comparison">
        <!-- FIX: Only show current plan section if there's an active plan -->
        <div class="current-plan-summary" *ngIf="activePlan && !isFreeTrial()">
          <h4>Current Plan</h4>
          <div class="plan-summary-card">
            <span class="plan-name">{{ activePlan.name }}</span>
            <span class="plan-price">${{ activePlan.price }}/month</span>
          </div>
        </div>

        <div class="current-plan-summary" *ngIf="activePlan && isFreeTrial()">
          <h4>Current Plan</h4>
          <div class="plan-summary-card">
            <span class="plan-name">{{ activePlan.name }}</span>
            <span class="plan-price">Free Trial</span>
          </div>
        </div>

        <div class="arrow-container" *ngIf="activePlan">
          <i class="fa-solid fa-arrow-right"></i>
        </div>

        <div class="new-plan-summary">
          <h4>{{ activePlan ? 'New Plan' : 'Selected Plan' }}</h4>
          <div class="plan-summary-card selected">
            <span class="plan-name">{{ selectedPlan?.name }}</span>
            <span class="plan-price">${{ selectedPlan?.price }}/month</span>
          </div>
        </div>
      </div>

      <div class="change-type-message">
        <!-- For Free Trial to Paid Plan -->
        <p *ngIf="isFreeTrial() && selectedPlan" class="upgrade-message">
          <i class="fa-solid fa-plus"></i>
          You are subscribing to the {{ selectedPlan.name }} plan. Your free trial will be converted to a paid
          subscription.
        </p>

        <!-- For Paid Plan Upgrades -->
        <p *ngIf="!isFreeTrial() && isUpgrade" class="upgrade-message">
          <i class="fa-solid fa-arrow-up"></i>
          You are upgrading to a higher tier plan. You'll get access to additional features immediately.
        </p>

        <!-- For Paid Plan Downgrades -->
        <p *ngIf="!isFreeTrial() && isDowngrade" class="downgrade-message">
          <i class="fa-solid fa-arrow-down"></i>
          You are downgrading to a lower tier plan. Some features may become unavailable.
        </p>

        <!-- For New Subscriptions (no active plan) -->
        <p *ngIf="!activePlan" class="new-subscription-message">
          <i class="fa-solid fa-plus"></i>
          You are subscribing to the {{ selectedPlan?.name }} plan.
        </p>
      </div>
    </div>

    <div class="confirmation-actions">
      <button class="cancel-button" (click)="closeConfirmationDialog()">
        Cancel
      </button>
      <button class="confirm-button" (click)="confirmPlanChange()">
        <ng-container *ngIf="!activePlan; else hasPlan">
          <span>Confirm Subscription</span>
        </ng-container>

        <ng-template #hasPlan>
          <span *ngIf="activePlan?.subscription_status === 'cancelled' && !activePlan?.is_active">
            Confirm Subscription
          </span>
          <span *ngIf="isUpgrade && activePlan?.is_active">Confirm Upgrade</span>
          <span *ngIf="isDowngrade && activePlan?.is_active">Confirm Downgrade</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>

<!-- Cancel Subscription Confirmation Dialog -->
<div *ngIf="showCancelDialog" class="confirmation-overlay">
  <div class="confirmation-dialog">
    <div class="confirmation-header">
      <h3><i class="fa-solid fa-exclamation-triangle text-red-500 mr-2"></i>Cancel Subscription</h3>
    </div>

    <div class="confirmation-content">
      <div class="cancel-warning">
        <div class="current-plan-info">
          <h4>Current Plan</h4>
          <div class="plan-summary-card">
            <span class="plan-name">{{ activePlan?.name }}</span>
            <span class="plan-price" *ngIf="!isFreeTrial()">${{ activePlan?.price }}/month</span>
            <span class="plan-price" *ngIf="isFreeTrial()">Free Trial</span>
          </div>
        </div>

        <div class="cancel-details">
          <h4>What happens when you cancel?</h4>

          <!-- Free Trial Cancellation Info -->
          <ul class="cancel-info-list" *ngIf="isFreeTrial()">
            <li><i class="fa-solid fa-check text-green-500 mr-2"></i>Your free trial will be cancelled immediately</li>
            <li><i class="fa-solid fa-times text-red-500 mr-2"></i>You will lose access to all trial features</li>
            <li><i class="fa-solid fa-info text-blue-500 mr-2"></i>You can start a new subscription anytime</li>
            <li><i class="fa-solid fa-info text-blue-500 mr-2"></i>No charges will be made</li>
          </ul>

          <!-- Paid Subscription Cancellation Info -->
          <ul class="cancel-info-list" *ngIf="!isFreeTrial()">
            <li><i class="fa-solid fa-check text-green-500 mr-2"></i>Your subscription will remain active until the end
              of your current billing period</li>
            <li><i class="fa-solid fa-check text-green-500 mr-2"></i>You'll continue to have access to all current
              features</li>
            <li><i class="fa-solid fa-times text-red-500 mr-2"></i>Your subscription will not auto-renew</li>
            <li><i class="fa-solid fa-info text-blue-500 mr-2"></i>You can resubscribe anytime before the end date</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="confirmation-actions">
      <button class="cancel-button" (click)="closeCancelDialog()">
        <span *ngIf="isFreeTrial()">Keep Free Trial</span>
        <span *ngIf="!isFreeTrial()">Keep Subscription</span>
      </button>
      <button class="confirm-button danger" (click)="confirmCancelSubscription()">
        <span *ngIf="!isCancelling && isFreeTrial()">Yes, Cancel Free Trial</span>
        <span *ngIf="!isCancelling && !isFreeTrial()">Yes, Cancel Subscription</span>
        <span *ngIf="isCancelling">
          <i class="fa-solid fa-spinner fa-spin mr-2"></i>Cancelling...
        </span>
      </button>
    </div>
  </div>
</div>